<template>
  <section class="faq-section">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-5 pe-md-5">
          <div class="position-relative">
            <img
              class="img-fluid rounded-4"
              src="@/assets/img/about/about-1.jpg"
              alt="img"
            />
            <div
              class="bg-warning text-center p-3 rounded-5 position-absolute top-0 end-0 z-index-1 d-none d-sm-block my-3 mx-3"
            >
              <i class="isax isax-message-question5 heading-color fs-46"></i>
            </div>
          </div>
        </div>
        <div class="col-lg-7">
          <div class="section-header">
            <span class="fw-medium text-secondary mb-2 d-inline-block section-badge"
              >FAQs</span
            >
            <h2>Frequently Asked Questions</h2>
            <p>
              Explore detailed answers to the most common questions about our platform.
            </p>
          </div>
          <div
            class="accordion accordion-customicon1 accordions-items-seperate"
            id="accordioncustomicon1Example"
          >
            <div class="accordion-item" data-aos="fade-up">
              <h2 class="accordion-header" id="headingcustomicon1One">
                <a
                  href="#"
                  class="accordion-button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapsecustomicon1One"
                  aria-expanded="true"
                  aria-controls="collapsecustomicon1One"
                >
                  What’s NextSense want to give you?
                  <i class="isax isax-add fs-20 fw-semibold ms-1"></i>
                </a>
              </h2>
              <div
                id="collapsecustomicon1One"
                class="accordion-collapse collapse show"
                aria-labelledby="headingcustomicon1One"
                data-bs-parent="#accordioncustomicon1Example"
              >
                <div class="accordion-body pt-0">
                  <p>
                    NextSense aims to provide you with a comprehensive and intuitive
                    learning platform that enhances your educational experience.
                  </p>
                </div>
              </div>
            </div>
            <div class="accordion-item" data-aos="fade-up" data-aos-delay="250">
              <h2 class="accordion-header" id="headingcustomicon1Two">
                <a
                  href="#"
                  class="accordion-button collapsed"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapsecustomicon1Two"
                  aria-expanded="false"
                  aria-controls="collapsecustomicon1One"
                >
                  Why choose us for your education?
                  <i class="isax isax-add fs-20 fw-semibold ms-1"></i>
                </a>
              </h2>
              <div
                id="collapsecustomicon1Two"
                class="accordion-collapse collapse"
                aria-labelledby="headingcustomicon1Two"
                data-bs-parent="#accordioncustomicon1Example"
              >
                <div class="accordion-body pt-0">
                  <p>
                    NextSense aims to provide you with a comprehensive and intuitive
                    learning platform that enhances your educational experience.
                  </p>
                </div>
              </div>
            </div>
            <div class="accordion-item" data-aos="fade-up" data-aos-delay="250">
              <h2 class="accordion-header" id="headingcustomicon1Three">
                <a
                  href="#"
                  class="accordion-button collapsed"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapsecustomicon1Three"
                  aria-expanded="false"
                  aria-controls="collapsecustomicon1One"
                >
                  How We Provide Service For you?
                  <i class="isax isax-add fs-20 fw-semibold ms-1"></i>
                </a>
              </h2>
              <div
                id="collapsecustomicon1Three"
                class="accordion-collapse collapse"
                aria-labelledby="headingcustomicon1Three"
                data-bs-parent="#accordioncustomicon1Example"
              >
                <div class="accordion-body pt-0">
                  <p>
                    NextSense aims to provide you with a comprehensive and intuitive
                    learning platform that enhances your educational experience.
                  </p>
                </div>
              </div>
            </div>
            <div class="accordion-item" data-aos="fade-up" data-aos-delay="250">
              <h2 class="accordion-header" id="headingcustomicon1Four">
                <a
                  href="#"
                  class="accordion-button collapsed"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapsecustomicon1Four"
                  aria-expanded="false"
                  aria-controls="collapsecustomicon1One"
                >
                  Do you have a monthly plan?
                  <i class="isax isax-add fs-20 fw-semibold ms-1"></i>
                </a>
              </h2>
              <div
                id="collapsecustomicon1Four"
                class="accordion-collapse collapse"
                aria-labelledby="headingcustomicon1Four"
                data-bs-parent="#accordioncustomicon1Example"
              >
                <div class="accordion-body pt-0">
                  <p>
                    NextSense aims to provide you with a comprehensive and intuitive
                    learning platform that enhances your educational experience.
                  </p>
                </div>
              </div>
            </div>
            <div class="accordion-item" data-aos="fade-up" data-aos-delay="250">
              <h2 class="accordion-header" id="headingcustomicon1Five">
                <a
                  href="#"
                  class="accordion-button collapsed"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapsecustomicon1Five"
                  aria-expanded="false"
                  aria-controls="collapsecustomicon1One"
                >
                  Are you Affordable For Your Course
                  <i class="isax isax-add fs-20 fw-semibold ms-1"></i>
                </a>
              </h2>
              <div
                id="collapsecustomicon1Five"
                class="accordion-collapse collapse"
                aria-labelledby="headingcustomicon1Five"
                data-bs-parent="#accordioncustomicon1Example"
              >
                <div class="accordion-body pt-0">
                  <p>
                    NextSense aims to provide you with a comprehensive and intuitive
                    learning platform that enhances your educational experience.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
